import React from "react";

const ITEMS = ["VER", "SENTIR", "CAPTURAR", "FOTOGRAFIA DESPORTIVA", "PORTUGAL", "ARTE", "MOVIMENTO"];

const MarqueeTrack = ({ reverse }) => (
  <div className={`marquee-track${reverse ? " marquee-track--reverse" : ""}`}>
    {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
      <span key={i} className="marquee-item">
        {item}
        <span className="marquee-sep" aria-hidden="true">•</span>
      </span>
    ))}
  </div>
);

const Marquee = ({ double = false }) => (
  <div className="marquee-section" aria-hidden="true">
    <MarqueeTrack reverse={false} />
    {double && <MarqueeTrack reverse={true} />}
  </div>
);

export default Marquee;
